import type { ReactNode } from "react";
import { PortableText } from "@portabletext/react";
import type { PortableTextBlock } from "sanity";

import { cn } from "@/lib/utils";
import type { GROQButton } from "@/sanity/lib/definitions";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { CTAButton } from "@/shadcn/ui/button";

export const TITLE_TRIM =
  "prose-p:[text-box-trim:trim-both] prose-p:[text-box-edge:cap_alphabetic] prose-headings:[text-box-trim:trim-both] prose-headings:[text-box-edge:cap_alphabetic]";

export function CommunityPortableText({
  value,
  className,
}: {
  value?: PortableTextBlock[];
  className?: string;
}) {
  if (!value?.length) return null;

  return (
    <div className={cn("richtext", className)}>
      <PortableText value={value} components={richTextComponent} />
    </div>
  );
}

interface CommunityChipProps {
  children: ReactNode;
  className?: string;
  color?: "blue" | "black";
  hideRight?: boolean;
}

export function CommunityChip({ children, className, color = "blue", hideRight = false }: CommunityChipProps) {
  const baseColor = color === "black" ? "0,0,0" : "184,210,226";

  return (
    <p
      className={cn(
        "m-0 font-jetbrainsmono text-[1.75rem] leading-[normal] font-normal uppercase",
        color === "black" ? "text-black" : "text-[#b8d2e2]",
        className,
      )}>
      <span style={{ color: `rgba(${baseColor},0.2)` }}>|</span>
      <span style={{ color: `rgba(${baseColor},0.4)` }}>|</span>
      <span style={{ color: `rgba(${baseColor},0.6)` }}>|</span>
      <span style={color === "blue" ? { color: `rgba(${baseColor},0.8)` } : undefined}> {children}</span>
      {!hideRight && (
        <>
          <span style={color === "blue" ? { color: `rgba(${baseColor},0.8)` } : undefined}> </span>
          <span style={{ color: `rgba(${baseColor},0.6)` }}>|</span>
          <span style={{ color: `rgba(${baseColor},0.4)` }}>|</span>
          <span style={{ color: `rgba(${baseColor},0.2)` }}>|</span>
        </>
      )}
    </p>
  );
}

interface CommunityCTAProps {
  cta?: GROQButton;
  className?: string;
  fullWidthMobile?: boolean;
}

export function CommunityCTA({ cta, className, fullWidthMobile = true }: CommunityCTAProps) {
  if (!cta) return null;

  return (
    <CTAButton
      data={cta}
      iconOverride="arrowRight"
      fullWidth={fullWidthMobile}
      className={cn(fullWidthMobile ? "w-full lg:w-auto" : "w-auto", className)}
    />
  );
}
